import { getIconList } from "../../services/iconLib";
import { listingReducer } from "../reducers/utils/listingReducer";

const { reducer, actions, types } = listingReducer({
  name: `iconLib`,
  getApi: getIconList,
});
const iconLib = reducer;
export { iconLib, actions, types };
